<button class="button-1"
    (click)="onClick()">
    <i class='material-icons save-icon' >attach_file</i> &nbsp;
    <span class="middle" >{{buttonText}}</span>
</button>